module.exports = __webpack_public_path__ + "img/40.472b4664.webp";